<template>
	<div>
		<div v-if="noModifyingRange">
			{{ modifier.static_modifying_range[0].toFixed() }}
		</div>
		<div v-if="!noModifyingRange">
			{{ modifier.static_modifying_range[0].toFixed() }}&mdash;
			{{ modifier.static_modifying_range[1].toFixed() }}
		</div>
		<div class="modifier-title">{{ modifier.property.names[locale] }}</div>
		<!-- <div>Duration: {{modifier.phase_lifecycle}}</div> -->
	</div>
</template>

<script>
// Other components
import { i18n } from "../utils";

export default {
	// Naming - server = srv
	name: "modifier",
	mixins: [i18n],
	props: ["modifier"],
	data: function () {
		return {};
	},
	computed: {
		noModifyingRange: function () {
			return (
				this.modifier.static_modifying_range[0] ==
				this.modifier.static_modifying_range[1]
			);
		},
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {},
	beforeDestroy() {},
	methods: {},
};
</script>
